import React from "react";
import PropTypes from "prop-types";

import { Column, Field, Control, Label, Input, Textarea } from "rbx";

import {
  CustomerSelect,
  StateSelect,
  BooleanInput,
  ZipCodeInput,
  SystemCodeSelect
} from "../inputs";

const LocationForm = ({ inputs, onChange }) => (
  <React.Fragment>
    <Column.Group>
      <Column>
        <Field kind="group">
          <Control expanded>
            <Label>Location Name</Label>
            <Input
              required
              autocomplete="new"
              name="LocationName"
              type="text"
              value={inputs.LocationName}
              onChange={onChange}
            />
          </Control>
          <Control>
            <Label>Delivery</Label>
            <BooleanInput
              name="DeliveryLocation"
              value={inputs.DeliveryLocation}
              onChange={onChange}
            />
          </Control>
          <Control>
            <Label>Pickup</Label>
            <BooleanInput
              name="PickupLocation"
              value={inputs.PickupLocation}
              onChange={onChange}
            />
          </Control>
          <Control>
            <Label>Active</Label>
            <BooleanInput
              name="Active"
              value={inputs.Active}
              onChange={onChange}
            />
          </Control>
        </Field>
        <Field kind="group">
          <Control expanded>
            <Label>Address 1</Label>
            <Input
              autocomplete="new"
              name="Address1"
              type="text"
              value={inputs.Address1}
              onChange={onChange}
            />
          </Control>
          <Control expanded>
            <Label>Address 2</Label>
            <Input
              autocomplete="new"
              name="Address2"
              type="text"
              value={inputs.Address2}
              onChange={onChange}
            />
          </Control>
        </Field>
        <Field kind="group">
          <Control expanded>
            <Label>City</Label>
            <Input
              autocomplete="new"
              name="City"
              type="text"
              value={inputs.City}
              onChange={onChange}
            />
          </Control>
          <Control>
            <Label>State</Label>
            <StateSelect
              name="State"
              size=""
              value={inputs.State}
              onChange={onChange}
            />
          </Control>
          <Control expanded>
            <Label>Zip Code</Label>
            <ZipCodeInput name="Zip" value={inputs.Zip} onChange={onChange} />
          </Control>
          <Control expanded>
            <Label>Country</Label>
            <Input
              autocomplete="new"
              name="Country"
              type="text"
              value={inputs.Country}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      <Column>
        <Field>
          <Control>
            <CustomerSelect
              icon="users"
              label="Bill To Customer"
              name="BillToRecIdRef"
              value={inputs.BillToRecIdRef}
              variables={{
                where: { Active: true, BillToCust: true },
                orderByMulti: ["CustomerNo_ASC"]
              }}
              onChange={onChange}
            />
          </Control>
        </Field>
        <Field>
          <Control expanded>
            <SystemCodeSelect
              icon="globe"
              label="Time Zone"
              lookup={{ Category: "Company", Code: "Time Zone" }}
              name="TimeZoneRecIdRef"
              value={inputs.TimeZoneRecIdRef}
              onChange={onChange}
            />
          </Control>
        </Field>
        <Field kind="group">
          <Control expanded>
            <Label>Loading Bays</Label>
            <Input
              autocomplete="new"
              name="NumberOfLoadingBays"
              type="number"
              value={inputs.NumberOfLoadingBays}
              onChange={onChange}
            />
          </Control>
          <Control expanded>
            <Label>Unloading Bays</Label>
            <Input
              autocomplete="new"
              label="NumberOfUnloadingBays"
              name="NumberOfUnloadingBays"
              type="number"
              value={inputs.NumberOfUnloadingBays}
              onChange={onChange}
            />
          </Control>
          <Control>
            <Label>Scales</Label>
            <BooleanInput
              name="Scales"
              value={inputs.Scales}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
    </Column.Group>
    <Field kind="group">
      <Control expanded>
        <Label>Special External Instructions</Label>
        <Textarea
          name="SpecialExternalInstructions"
          rows="2"
          value={inputs.SpecialExternalInstructions}
          onChange={onChange}
        />
      </Control>

      <Control expanded>
        <Label>Internal Notes</Label>
        <Textarea
          name="InternalNotes"
          rows="2"
          value={inputs.InternalNotes}
          onChange={onChange}
        />
      </Control>
    </Field>
  </React.Fragment>
);

LocationForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};
LocationForm.defaultProps = {
  inputs: {}
};
export default LocationForm;
